import { useState, useCallback } from 'react';

const useChatMessages = () => {
    const [messages, setMessages] = useState([]);
    const [isBotTyping, setIsBotTyping] = useState(false);
    const [entities, setEntities] = useState({});

    const appendMessage = useCallback((message) => {
        setMessages(prev => [...prev, message]);
    }, []);

    const popLastMessage = useCallback(() => {
        setMessages(prev => prev.slice(0, -1));
    }, []);

    const setBotTyping = useCallback((typing) => {
        setIsBotTyping(typing);
    }, []);

    const mergeEntities = useCallback((newEntities) => {
        setEntities(prev => ({ ...prev, ...newEntities }));
    }, []);

    const clearMessages = useCallback(() => {
        setMessages([]);
    }, []);

    return { messages, isBotTyping, entities, appendMessage, popLastMessage, setBotTyping, mergeEntities, clearMessages };
};

export default useChatMessages;
